import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import * as S from './NavigationButton.styles';

interface NavigationButtonProps {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
}

export default function NavigationButton({
  direction,
  onClick,
  disabled = false,
}: NavigationButtonProps) {
  return (
    <S.Button 
      direction={direction} 
      onClick={onClick} 
      disabled={disabled}
      aria-label={direction === 'left' ? 'Imagem anterior' : 'Próxima imagem'}
    >
      {direction === 'left' ? <LeftOutlined /> : <RightOutlined />}
    </S.Button>
  );
}